import styled from "styled-components";
import { rhythm } from "Themes/typography";

const InnerContainer = styled.div`
  padding: ${rhythm(1.5)} ${rhythm(2.5)};
`;

export default InnerContainer;
